// Generated by ReScript, PLEASE EDIT WITH CARE
/* @generated */
'use strict';

let RescriptRelay = require("rescript-relay/src/RescriptRelay.bs.js");

let Types = {};

let fragmentConverter = {"__root":{"":{"f":""}}};

function convertFragment(v) {
  return RescriptRelay.convertObj(v, fragmentConverter, undefined, undefined);
}

let Internal = {
  fragmentConverter: fragmentConverter,
  fragmentConverterMap: undefined,
  convertFragment: convertFragment
};

let Utils = {};

let node = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EditMarketingProfileMember_page_marketingProfileMember",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMarketingProfileMember_header_marketingProfileMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMarketingProfileMemberInfoForm_marketingProfileMember"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "MarketingProfileMemberPhotoForm_agentMarketingProfile"
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EditMarketingProfileMemberSocialAccountsForm_marketingProfileMember"
    }
  ],
  "type": "MarketingProfileMember",
  "abstractKey": null
};

exports.Types = Types;
exports.Internal = Internal;
exports.Utils = Utils;
exports.node = node;
/* RescriptRelay Not a pure module */
